if (!customElements.get('component-reward-popup')) {
  customElements.define('component-reward-popup', class rewardPopupComponent extends HTMLElement {
    constructor() {
      super();
      this.closeButton = this.querySelector(".component-reward-popup-close");
      this.overlay = this.querySelector(".component-reward-popup-overlay");
    }

    connectedCallback() {
      this.addEventListeners();
    }

    open() {
      document.body.classList.add('overflow-hidden-tablet');
      this.removeAttribute('hidden');
    }

    close() {
      this.setAttribute('hidden', '');
      document.body.classList.remove('overflow-hidden-tablet');
    }

    _handleCloseButtonClick() {
      this.close();
    }

    _handleOverlayClick() {
      this.close();
    }

    addEventListeners() {
      this.closeButton.addEventListener('click', this._handleCloseButtonClick.bind(this));
      this.overlay.addEventListener('click', this._handleCloseButtonClick.bind(this));
    }
  })
}
